import React from 'react';
import Checkbox from 'material-ui/Checkbox';
import ToggleCheckBox from 'material-ui/svg-icons/toggle/check-box';
import ToggleCheckBoxOutlineBlank from 'material-ui/svg-icons/toggle/check-box-outline-blank';

/**
 * <StringSearchFieldSuggestionWithCheckbox /> renders a suggestion string to the right of
 * a <Checkbox /> in order to show whether a suggestion has already been selected by a user
 * or not
 */
class StringSearchFieldSuggestionWithCheckbox extends React.Component {
  render() {
    return (
      <Checkbox
        label={this.props.label}
        checked={this.props.checked}
        value={this.props.value}
        checkedIcon={<ToggleCheckBox color="#0288D1" />}
        uncheckedIcon={<ToggleCheckBoxOutlineBlank color="#9E9E9E" />}></Checkbox>
    );
  }
}

export default StringSearchFieldSuggestionWithCheckbox;
